module.exports = __webpack_public_path__ + "img/tusi2.fd32a394.svg";